import React, { useState, useEffect } from "react";
import DataTableBase from "../../components/DataTableWSearch";
import GenBtn from "../../components/GenBtn";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Banner from "../common/Banner";
import { getList } from "./actions";
import * as Fa from "react-icons/fa";
import LoadMask from "../../Utils/LoadMask/LoadMask";

const BannerText = "Tipos de abono";

function Listado({ history, ...props }) {
    const [tableData, setTableData] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const columns = [
        {
            name: "Nombre",
            selector: (row) => row.nombre,
            sortable: false,
        },
        {
            cell: (row) => (
                <GenBtn
                    key={row.id}
                    textColor="hsl(0, 0%, 80%)"
                    background="hsla(0, 100%, 100%, 0.2)"
                    toolTipText="Editar"
                    onPress={(e) => {
                        history.push(
                            `${history.location.pathname}/editar/${row.id}`
                        );
                    }}
                >
                    <Fa.FaPen />
                </GenBtn>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            cell: (row) => (
                <GenBtn
                    textColor="hsl(50, 50%, 80%)"
                    background="hsla(50, 50%, 80%, 0.2)"
                    toolTipText="Ver"
                    onPress={(e) => {
                        history.push(
                            `${history.location.pathname}/ver/${row.id}`
                        );
                    }}
                >
                    <Fa.FaEye />
                </GenBtn>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    async function fetchData() {
        const data = await getList();
        setTableData(data);
        setIsLoading(false);
    }
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <main>
            <Banner>{BannerText}</Banner>
            <GenBtn onPress={() => (location.href += "/crear")}>Crear</GenBtn>
            <LoadMask loading={isLoading} color="#bd0034" blur={true}>
                <DataTableBase data={tableData} columns={columns} />
            </LoadMask>
        </main>
    );
}

export default withRouter(Listado);
